import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const mapyMapmenuMapsetOptionCss = ":host{display:flex;justify-content:space-between;align-items:center;align-self:stretch;color:#011e39;font-family:Arial, Helvetica, sans-serif;font-size:14px;font-style:normal;font-weight:400;line-height:20px;user-select:none;gap:8px}";

const MapyMapmenuMapsetOption$1 = /*@__PURE__*/ proxyCustomElement(class MapyMapmenuMapsetOption extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
  }
  render() {
    return h(Host, null, h("slot", null));
  }
  get hostElement() { return this; }
  static get style() { return mapyMapmenuMapsetOptionCss; }
}, [1, "mapy-mapmenu-mapset-option"]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["mapy-mapmenu-mapset-option"];
  components.forEach(tagName => { switch (tagName) {
    case "mapy-mapmenu-mapset-option":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, MapyMapmenuMapsetOption$1);
      }
      break;
  } });
}
defineCustomElement$1();

const MapyMapmenuMapsetOption = MapyMapmenuMapsetOption$1;
const defineCustomElement = defineCustomElement$1;

export { MapyMapmenuMapsetOption, defineCustomElement };

//# sourceMappingURL=mapy-mapmenu-mapset-option.js.map